var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-container',{staticStyle:{"max-width":"1285px"}},[_c('v-row',{staticClass:"text-center"},[_c('v-col',{staticStyle:{"padding":"0"},attrs:{"cols":"12"}},[_c('div',{ref:"viewer",staticClass:"vue-pano-viewer",style:(_vm.size),attrs:{"id":"panorama"}})])],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }